import * as types from '../types/couponTypes';

const initialState = {
  coupons: [],
  coupon: null,
  loading: false,
  error: null,
};

function couponReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COUPONS_REQUEST:
    case types.FETCH_COUPON_BY_ID_REQUEST:
    case types.CREATE_COUPON_REQUEST:
    case types.UPDATE_COUPON_REQUEST:
    case types.DELETE_COUPON_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_COUPONS_SUCCESS:
      return { ...state, loading: false, coupons: action.payload };
    case types.FETCH_COUPON_BY_ID_SUCCESS:
      return { ...state, loading: false, coupon: action.payload };
    case types.CREATE_COUPON_SUCCESS:
      return { ...state, loading: false, coupons: [...state.coupons, action.payload] };
    case types.UPDATE_COUPON_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        coupons: state.coupons.map((c) => (c._id === updated._id ? updated : c)),
        coupon: state.coupon && state.coupon._id === updated._id ? updated : state.coupon,
      };
    }
    case types.DELETE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: state.coupons.filter((c) => c._id !== action.payload),
        coupon: state.coupon && state.coupon._id === action.payload ? null : state.coupon,
      };
    case types.FETCH_COUPONS_FAILURE:
    case types.FETCH_COUPON_BY_ID_FAILURE:
    case types.CREATE_COUPON_FAILURE:
    case types.UPDATE_COUPON_FAILURE:
    case types.DELETE_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default couponReducer;
